export default __webpack_public_path__ + "static/media/dog-barking.e65e4db3.png";